<template>
  <div class="container-fluid h-100">
    <div class="container">
      <div class="mt-5 pt-4 row justify-content-center">
        <div class="col-12 mb-3">
          <label style="color: #616161;"><b>EDITAR PRODUCTO</b></label><br/>
        </div>

        <div class="col-12 m-0 p-0">
          <div class="form-group">
            <div class="row" style="text-align: left">
              <div class="col-7  m-0 p-0">
                <div class="row">
                  <div class="col-12">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color: #616161; font-size: 14px"
                        ><b>Nombre *</b>
                      </label>
                      <input
                        :class="{ 'is-danger': errors.name }"
                        type="text"
                        v-model="form.name"
                        class="form-control"
                        placeholder="Escribe aquí el nombre del producto "
                      />
                    </div>
                    <span
                      v-if="errors.name"
                      class="text-danger float-left small error-danger mb-2"
                      >{{ errors.name }}</span
                    >
                  </div>
                  <div class="col-6">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color: #616161; font-size: 14px"
                        ><b>Estado del producto * </b>
                      </label>
                      <select
                        :class="{ 'is-danger': errors.status }"
                        class="form-control"
                        name="state"
                        id="state"
                        v-model="form.status"
                      >
                        <option value="null" disabled selected
                          >Seleccione el estado de producto
                        </option>
                        <option value="1">Activo</option>
                        <option value="2">Inactivo</option>
                      </select>
                    </div>
                    <span
                      v-if="errors.status"
                      class="text-danger float-left small error-danger mb-2"
                      >{{ errors.status }}</span
                    >
                  </div>

                  <div class="col-6">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color:#616161; font-size:14px"
                      ><b>Tipo de catálogo *</b>
                      </label>
                      <select
                        :class="{ 'is-danger': errors.type_catalogue }"
                        class="form-control"
                        name="state"
                        id="state"
                        v-model="form.type_catalogue"
                      >
                        <option value="null" disabled selected>Seleccione el tipo de catálogo</option>
                        <option value="1">Motero</option>
                        <option value="2">Lubricador</option>
                        <option value="3">Motero y Lubricador</option>
                        <option value="4">Puntos de Venta</option>
                      </select>
                    </div>
                    <span
                      v-if="errors.type_catalogue"
                      class="text-danger float-left small error-danger mb-2"
                    >{{ errors.type_catalogue }}</span
                    >
                  </div>
                  <!-- si se escoge Todos en el tipo de catálogo -->
                  <div v-if="form.type_catalogue == 1 || form.type_catalogue == 3 || form.type_catalogue == 4" class="col-4">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color: #616161; font-size: 14px"
                      ><b>Puntos *</b>
                      </label>
                      <input
                        :class="{ 'is-danger': errors.points }"
                        type="number"
                        v-model="form.points"
                        class="form-control"
                        placeholder="Escribe aquí los puntos del producto"
                      />
                    </div>
                    <span
                      v-if="errors.points"
                      class="text-danger float-left small error-danger mb-2"
                    >{{ errors.points }}</span
                    >
                  </div>
                  <!-- si se escoge Lubricador en el tipo de catálogo -->
                  <div v-if="form.type_catalogue == 2 || form.type_catalogue == 3" class="col-4">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color: #616161; font-size: 14px"
                      ><b>Puntos Lubricador *</b>
                      </label>
                      <input
                        :class="{ 'is-danger': errors.points_lub }"
                        type="number"
                        v-model="form.points_lub"
                        class="form-control"
                        placeholder="Escribe aquí los puntos del producto"
                      />
                    </div>
                    <span
                      v-if="errors.points_lub"
                      class="text-danger float-left small error-danger mb-2"
                    >{{ errors.points_lub }}</span
                    >
                  </div>

                  <!-- <div class="col-6">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color: #616161; font-size: 14px"
                        ><b>Puntos *</b>
                      </label>
                      <input
                        :class="{ 'is-danger': errors.points }"
                        type="number"
                        v-model="form.points"
                        class="form-control"
                        placeholder="Escribe aquí los puntos del producto"
                      />
                    </div>
                    <span
                      v-if="errors.points"
                      class="text-danger float-left small error-danger mb-2"
                      >{{ errors.points }}</span
                    >
                  </div> -->

                  <div class="col-4">
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color: #616161; font-size: 14px"
                        ><b>Precio *</b>
                      </label>
                      <input
                        :class="{ 'is-danger': errors.price }"
                        type="number"
                        v-model="form.price"
                        class="form-control"
                        placeholder="Escribe aquí el precio del producto"
                      />
                    </div>
                    <span
                      v-if="errors.price"
                      class="text-danger float-left small error-danger mb-2"
                      >{{ errors.price }}</span
                    >
                  </div>
                  <div class="col-4 pt-5" v-if="form.type_id == 6">
                    <span class="text-body"><b></b></span>
                    <div class="form-group">
                      <input
                        type="checkbox"
                        id="checkbox"
                        v-model="form.checked"
                      />
                      <label
                        class="ml-1"
                        for="state"
                        style="color: #616161; font-size: 14px"
                        ><b>Actualizar producto.</b>
                        <i
                          class="fa fa-info-circle text-info ml-1"
                          style="font-size: 20px;"
                          aria-hidden="true"
                          data-bs-toggle="tooltip"
                          data-bs-placement="bottom"
                          title="Si esta opción es verdadera los productos se actualizarán con el api de zwapp"
                        ></i>
                      </label>
                    </div>
                  </div>
                  <!-- 
                  <div
                    class="col-4"
                    v-if="form.type_id == 3 || form.type_id == 5"
                  >
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color: #616161; font-size: 14px"
                        ><b>Stock *</b>
                      </label>
                      <input
                        type="number"
                        v-model="form.stock"
                        class="form-control"
                        placeholder="Escribe aquí el stock del producto"
                      />
                    </div>
                  </div> -->

                  <div
                    class="col-4"
                    v-if="form.type_id == 3 || form.type_id == 5"
                  >
                    <div class="form-group">
                      <label
                        class="ml-1"
                        for="state"
                        style="color: #616161; font-size: 14px"
                        ><b>SKU </b>
                      </label>
                      <input
                        type="text"
                        v-model="form.sku"
                        class="form-control"
                        placeholder="Escribe aquí el sku"
                      />
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-5 m-0 p-0">
                <div class="form-group">
                  <label
                    class="ml-1"
                    for="state"
                    style="color: #616161; font-size: 14px"
                    ><b>Descripción del producto *</b>
                  </label>
                  <textarea
                    :class="{ 'is-danger': errors.description }"
                    rows="8"
                    type="text"
                    v-model="form.description"
                    class="form-control"
                    placeholder="Escribe aquí la descripción del producto"
                  />
                </div>
                <span
                  v-if="errors.description"
                  class="text-danger float-left small error-danger mb-2"
                  >{{ errors.description }}</span
                >
              </div>
            </div>
          </div>
        </div>

        <div class="hr-border"></div>
        <div class="col-6" style="text-align: initial">
          <div class="form-group">
            <label
              class="ml-1"
              for="state"
              style="color: #616161; font-size: 14px"
            ><b>Tipo de talla {{ form.type_catalogue == 3 ? 'Motero' : '' }} *</b>
            </label>
            <select
              :class="{ 'is-danger': errors.talla }"
              class="form-control"
              name="state"
              id="state"
              v-model="sizes.info"
            >
              <option value="null" disabled selected
              >Seleccione una talla
              </option>
              <option v-for="data in listSizes" :key="data.id" :value="data">
                {{ data.name }}
              </option>
            </select>
          </div>
        </div>

        <div class="col-5" style="text-align: initial">
          <label
            class="ml-1"
            for="state"
            style="color: #616161; font-size: 14px"
          ><b>Cantidad *</b>
          </label>
          <input
            type="text"
            v-model="sizes.availability"
            class="form-control"
            placeholder="Escribe aquí la cantidad de productos para esa talla"
          />
        </div>

        <div class="col-1">
          <label
            class="ml-1"
            for="state"
            style="color: #616161; font-size: 14px"
          ><b>Agregar</b>
          </label>
          <button @click="addSizes()" class="btn btn-info">+</button>
        </div>

        <div class="col-12" style="text-align: initial">
          <label for="image" style="color:#616161; font-size:14px;">
            <b>Tallas</b>
          </label>
        </div>

        <div class="col-12">
          <div
            v-if="form.sizes.length == 0"
            class="alert alert-primary"
            role="alert"
          >
            No hay tallas seleccionadas {{ form.type_catalogue == 3 ? 'para Motero' : '' }}
          </div>

          <template v-for="(data, i) in form.sizes">
            <button
              :key="data.id"
              type="button"
              class="btn btn-primary mb-3 ml-3"
            >
            <template>
              <template v-if="data.name != null">
                <strong> {{ data.name }} </strong>
              </template>
              <span class="badge badge-light ml-2">
                {{ data.availability }}
              </span>
              <i
                style="padding-left:5px"
                @click="removeSize(i)"
                class="fa fa-close icon ml-2 text-dark"
              ></i>
            </template>
            </button>
          </template>
          <div style="margin:15px;">
            <p style="color:#616161; font-size:15px;">
              <b>Historial de tallas y cantidades para Motero</b>
            </p>
            <!-- Cantidad de tallas agregadas inicialmente -->
            <template>
              <button
                style="font-size:15px;"
                type="button"
                class="btn btn-primary mb-3 ml-3"
                @click="showCantAdd_M()"
              >
                <b>Cantidad de tallas agregadas</b>
              </button>
            </template>

            <!-- Modal cantidades de tallas agregadas inicialmente -->
            <div
              class="modal fade"
              id="modalSizesAdd_M"
              tabindex="-1"
              role="dialog"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-dialog-centered" role="document">
                <div style="padding:10px 20px 10px 20px" class="modal-content">
                  <div id="boton_rrss">
                    <button
                      type="button"
                      class="close close-info-l"
                      @click="closedModal()"
                    >
                      X
                    </button>
                  </div>
                  <div>
                    <p style="color:#616161; font-size:18px;">
                      <b>Cantidad de tallas agregadas</b>
                    </p>
                    <template v-for="cant in form.sizes">
                      <button
                        type="button"
                        class="btn btn-primary mb-3 ml-3"
                      >
                        <template>
                          <template v-if="cant.name != null">
                            <strong>Talla: {{ cant.name }}</strong>
                          </template>
                          <span class="badge badge-light ml-2">
                            {{ cant.amount_total }}
                          </span>
                        </template>
                      </button>
                    </template>
                    <template>
                      <button
                        type="button"
                        class="btn btn-danger mb-3 ml-3"
                      >
                        <template>
                          <strong>Total agregadas:</strong>
                          <span class="badge badge-light ml-2">
                            {{ total_M }}
                          </span>
                        </template>
                      </button>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <!-- Fin modal cantidades de tallas agregadas inicialmente -->

            <!-- Cantidad de tallas redimidas -->
            <template>
              <button
                style="font-size:15px;"
                type="button"
                class="btn btn-primary mb-3 ml-3"
                @click="showCantRedeem_M()"
              >
                <b>Cantidad de tallas redimidas</b>
              </button>
            </template>

            <!-- Modal cantidades de tallas redimidas -->
            <div
              class="modal fade"
              id="modalSizesRedeem_M"
              tabindex="-1"
              role="dialog"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-dialog-centered" role="document">
                <div style="padding:10px 20px 10px 20px" class="modal-content">
                  <div id="boton_rrss">
                    <button
                      type="button"
                      class="close close-info-l"
                      @click="closedModal()"
                    >
                      X
                    </button>
                  </div>
                  <div>
                    <p style="color:#616161; font-size:18px;">
                      <b>Cantidad de tallas redimidas</b>
                    </p>
                    <template v-for="cant in form.sizes">
                      <button
                        type="button"
                        class="btn btn-primary mb-3 ml-3"
                      >
                        <template>
                          <template v-if="cant.name != null">
                            <strong>Talla: {{ cant.name }}</strong>
                          </template>
                          <span class="badge badge-light ml-2">
                            {{ cant.amount_redeemed }}
                          </span>
                        </template>
                      </button>
                    </template>
                    <template>
                      <button
                        type="button"
                        class="btn btn-danger mb-3 ml-3"
                      >
                        <template>
                          <strong>Total redimidas:</strong>
                          <span class="badge badge-light ml-2">
                            {{ total_redeemed_M }}
                          </span>
                        </template>
                      </button>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <!-- Fin modal cantidades de tallas redimidas -->

            <!-- Cantidad de tallas restantes -->
            <template>
              <button
                style="font-size:15px;"
                type="button"
                class="btn btn-primary mb-3 ml-3"
                @click="showCantRemaining_M()"
              >
                <b>Cantidad de tallas restantes</b>
              </button>
            </template>

            <!-- Modal cantidades de tallas restantes -->
            <div
              class="modal fade"
              id="modalSizesRemaining_M"
              tabindex="-1"
              role="dialog"
              aria-labelledby="exampleModalLabel"
              aria-hidden="true"
            >
              <div class="modal-dialog modal-dialog-centered" role="document">
                <div style="padding:10px 20px 10px 20px" class="modal-content">
                  <div id="boton_rrss">
                    <button
                      type="button"
                      class="close close-info-l"
                      @click="closedModal()"
                    >
                      X
                    </button>
                  </div>
                  <div>
                    <p style="color:#616161; font-size:18px;">
                      <b>Cantidad de tallas restantes</b>
                    </p>
                    <template v-for="cant in form.sizes">
                      <button
                        type="button"
                        class="btn btn-primary mb-3 ml-3"
                      >
                        <template>
                          <template v-if="cant.name != null">
                            <strong>Talla: {{ cant.name }}</strong>
                          </template>
                          <span class="badge badge-light ml-2">
                            {{ cant.amount_remaining }}
                          </span>
                        </template>
                      </button>
                    </template>
                    <template>
                      <button
                        type="button"
                        class="btn btn-danger mb-3 ml-3"
                      >
                        <template>
                          <strong>Total restantes:</strong>
                          <span class="badge badge-light ml-2">
                            {{ total_remaining_M }}
                          </span>
                        </template>
                      </button>
                    </template>
                  </div>
                </div>
              </div>
            </div>
            <!-- Fin modal cantidades de tallas restantes -->
          </div>
        </div>
        <div class="hr-border"></div>

        <!-- Tallas de productos para Lubricadores -->
        <template v-if="form.type_catalogue == 3">
          <div class="col-6" style="text-align: initial">
            <div class="form-group">
              <label
                class="ml-1"
                for="state"
                style="color: #616161; font-size: 14px"
              ><b>Tipo de talla {{ form.type_catalogue == 3 ? 'Lubricador' : '' }} *</b>
              </label>
              <select
                :class="{ 'is-danger': errors.talla }"
                class="form-control"
                name="state"
                id="state"
                v-model="sizes_lub.info"
              >
                <option value="null" disabled selected
                >Seleccione una talla
                </option>
                <option v-for="data in listSizes" :key="data.id" :value="data">
                  {{ data.name }}
                </option>
              </select>
            </div>
          </div>

          <div class="col-5" style="text-align: initial">
            <label
              class="ml-1"
              for="state"
              style="color: #616161; font-size: 14px"
            ><b>Cantidad *</b>
            </label>
            <input
              type="text"
              v-model="sizes_lub.availability"
              class="form-control"
              placeholder="Escribe aquí la cantidad de productos para esa talla"
            />
          </div>

          <div class="col-1">
            <label
              class="ml-1"
              for="state"
              style="color: #616161; font-size: 14px"
            ><b> Agregar </b>
            </label>
            <button @click="addSizesLub()" class="btn btn-info">+</button>
          </div>

          <div class="col-12" style="text-align: initial">
            <label for="image" style="color:#616161; font-size:14px;">
              <b>Tallas</b>
            </label>
          </div>

          <div class="col-12">
            <div
              v-if="form.sizes_lub.length == 0"
              class="alert alert-primary"
              role="alert"
            >
              No hay tallas seleccionadas {{ form.type_catalogue == 3 ? 'para Lubricador' : '' }}
            </div>

            <template v-for="(data, i) in form.sizes_lub">
              <button
                type="button"
                class="btn btn-primary mb-3 ml-3"
              >
              <template>
                <template v-if="data.name != null">
                  <strong> {{ data.name }} </strong>
                </template>
                <span class="badge badge-light ml-2">
                  {{ data.availability }}
                </span>
                <i
                  style="padding-left:5px"
                  @click="removeSizeLub(i)"
                  class="fa fa-close icon ml-2 text-dark"
                ></i>
              </template>
              </button>
            </template>
            <div style="margin:15px;">
              <p style="color:#616161; font-size:15px;">
                <b>Historial de tallas y cantidades para Lubricador</b>
              </p>
              <!-- Cantidad de tallas agregadas inicialmente -->
              <template>
                <button
                  style="font-size:15px;"
                  type="button"
                  class="btn btn-primary mb-3 ml-3"
                  @click="showCantAdd_L()"
                >
                  <b>Cantidad de tallas agregadas</b>
                </button>
              </template>

              <!-- Modal cantidades de tallas agregadas inicialmente -->
              <div
                class="modal fade"
                id="modalSizesAdd_L"
                tabindex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-dialog-centered" role="document">
                  <div style="padding:10px 20px 10px 20px" class="modal-content">
                    <div id="boton_rrss">
                      <button
                        type="button"
                        class="close close-info-l"
                        @click="closedModal()"
                      >
                        X
                      </button>
                    </div>
                    <div>
                      <p style="color:#616161; font-size:18px;">
                        <b>Cantidad de tallas agregadas</b>
                      </p>
                      <template v-for="cant in form.sizes_lub">
                        <button
                          type="button"
                          class="btn btn-primary mb-3 ml-3"
                        >
                          <template>
                            <template v-if="cant.name != null">
                              <strong>Talla: {{ cant.name }}</strong>
                            </template>
                            <span class="badge badge-light ml-2">
                              {{ cant.amount_total }}
                            </span>
                          </template>
                        </button>
                      </template>
                      <template>
                        <button
                          type="button"
                          class="btn btn-danger mb-3 ml-3"
                        >
                          <template>
                            <strong>Total agregadas:</strong>
                            <span class="badge badge-light ml-2">
                              {{ total_L }}
                            </span>
                          </template>
                        </button>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Fin modal cantidades de tallas agregadas inicialmente -->

              <!-- Cantidad de tallas redimidas -->
              <template>
                <button
                  style="font-size:15px;"
                  type="button"
                  class="btn btn-primary mb-3 ml-3"
                  @click="showCantRedeem_L()"
                >
                  <b>Cantidad de tallas redimidas</b>
                </button>
              </template>

              <!-- Modal cantidades de tallas redimidas -->
              <div
                class="modal fade"
                id="modalSizesRedeem_L"
                tabindex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-dialog-centered" role="document">
                  <div style="padding:10px 20px 10px 20px" class="modal-content">
                    <div id="boton_rrss">
                      <button
                        type="button"
                        class="close close-info-l"
                        @click="closedModal()"
                      >
                        X
                      </button>
                    </div>
                    <div>
                      <p style="color:#616161; font-size:18px;">
                        <b>Cantidad de tallas redimidas</b>
                      </p>
                      <template v-for="cant in form.sizes_lub">
                        <button
                          type="button"
                          class="btn btn-primary mb-3 ml-3"
                        >
                          <template>
                            <template v-if="cant.name != null">
                              <strong>Talla: {{ cant.name }}</strong>
                            </template>
                            <span class="badge badge-light ml-2">
                              {{ cant.amount_redeemed }}
                            </span>
                          </template>
                        </button>
                      </template>
                      <template>
                        <button
                          type="button"
                          class="btn btn-danger mb-3 ml-3"
                        >
                          <template>
                            <strong>Total redimidas:</strong>
                            <span class="badge badge-light ml-2">
                              {{ total_redeemed_L }}
                            </span>
                          </template>
                        </button>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Fin modal cantidades de tallas redimidas -->

              <!-- Cantidad de tallas restantes -->
              <template>
                <button
                  style="font-size:15px;"
                  type="button"
                  class="btn btn-primary mb-3 ml-3"
                  @click="showCantRemaining_L()"
                >
                  <b>Cantidad de tallas restantes</b>
                </button>
              </template>

              <!-- Modal cantidades de tallas restantes -->
              <div
                class="modal fade"
                id="modalSizesRemaining_L"
                tabindex="-1"
                role="dialog"
                aria-labelledby="exampleModalLabel"
                aria-hidden="true"
              >
                <div class="modal-dialog modal-dialog-centered" role="document">
                  <div style="padding:10px 20px 10px 20px" class="modal-content">
                    <div id="boton_rrss">
                      <button
                        type="button"
                        class="close close-info-l"
                        @click="closedModal()"
                      >
                        X
                      </button>
                    </div>
                    <div>
                      <p style="color:#616161; font-size:18px;">
                        <b>Cantidad de tallas restantes</b>
                      </p>
                      <template v-for="cant in form.sizes_lub">
                        <button
                          type="button"
                          class="btn btn-primary mb-3 ml-3"
                        >
                          <template>
                            <template v-if="cant.name != null">
                              <strong>Talla: {{ cant.name }}</strong>
                            </template>
                            <span class="badge badge-light ml-2">
                              {{ cant.amount_remaining }}
                            </span>
                          </template>
                        </button>
                      </template>
                      <template>
                        <button
                          type="button"
                          class="btn btn-danger mb-3 ml-3"
                        >
                          <template>
                            <strong>Total restantes:</strong>
                            <span class="badge badge-light ml-2">
                              {{ total_remaining_L }}
                            </span>
                          </template>
                        </button>
                      </template>
                    </div>
                  </div>
                </div>
              </div>
              <!-- Fin modal cantidades de tallas restantes -->
            </div>
          </div>
          <div class="hr-border"></div>
        </template>

        <!-- BOTON -->
        <div class="col-12" style="text-align: end">
          <button
            @click="updatePublication()"
            type="button"
            class="btn btn-danger btn-sm button-login"
          >
            <template v-if="loading.changeDoc">
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              Cargando...
            </template>
            <template v-else>Editar producto</template>
          </button>
        </div>

        <!-- IMAGENES -->
        <div v-if="form.type_id != 6 && listFile.length > 0" class="col-12">
          <form ref="form" style="text-align: initial">
            <label for="image" style="color: #616161; font-size: 14px"
              ><b>Subir imagen *</b></label
            ><br />
            <input
              type="file"
              multiple
              accept="image/*"
              id="image"
              name="image"
              class="form-control-file mb-2"
              style="color: black"
              @change="onfileSelected($event)"
              ref="fileInput"
              :class="{ 'is-danger': errorsFile || errorsFile2 }"
            />
            <span v-if="errorsFile2" class="text-danger small error-danger">{{
              errorsFile2
            }}</span>
            <span v-if="errorsFile" class="text-danger small error-danger">{{
              errorsFile
            }}</span
            ><br />
          </form>
          <div
            class="commentary1"
            style="text-align: left; color: #1da5df; font-size: 13px;"
          >
            <span
              >RECOMENDACIÓN: solo se permiten imagenes en formato
              (jpg,jpeg,png).
            </span>
            <span>El tamaño maximo de 1MB.</span><br />
            <span
              >Para dispositivos de escritorio el tamaño de la imagen debe ser
              250 x 250 pixeles.</span
            >
          </div>
        </div>

        <!-- LISTA DE IMAGENES -->
        <div v-if="loading.table">
          <div
            class="spinner-border text-danger"
            style="width: 3rem; height: 3rem;"
            role="status"
          >
            <span class="visually-hidden"> </span>
          </div>
        </div>

        <div v-else-if="this.form.type_id != 6" class="col-12 mt-3">
          <table v-if="listFile.length > 0" class="table table-sm">
            <thead>
              <tr>
                <th scope="col">Principal</th>
                <th scope="col">Imágenes</th>
                <th scope="col">Nombre</th>
                <th scope="col">Acción</th>
              </tr>
            </thead>
            <tbody>
              <template v-for="(data, i) in listFile">
                <tr v-if="data.index == null" :key="data.id">
                  <td>
                    <input
                      type="radio"
                      title="Establecer imagen principal"
                      id="mainImage"
                      name="mainImage"
                      :value="data"
                      :checked="data.principal == true"
                      @click="mainImage = data.id"
                    />
                  </td>
                  <td>
                    <img width="100" :src="data.url"/>
                  </td>
                  <td v-if="data.principal == true">
                    <b style="color:#dc3545">{{ "Imagen principal del producto" }}</b>
                  </td>
                  <td v-else></td>
                  <td>
                    <button
                      class="btn btn-sm btn-danger mt-0 pt-0 mb-0 pb-0 ml-2 pl-2 mr-2 pr-2"
                      title="Eliminar"
                      @click="deleteImg(data, i)"
                    >
                      <i class="fa fa-close m-0 p-0" aria-hidden="true"></i>
                    </button>
                  </td>
                </tr>
                <tr v-else>
                  <td></td>
                  <td>
                    <img
                      width="100"
                      :class="`img-h-${data.index}`"
                      class="mr-3"
                      alt="Imágenes"
                    />
                  </td>
                  <td>{{ data.name }}</td>
                  <td>
                    <button
                      class="btn btn-sm btn-danger mt-0 pt-0 mb-0 pb-0 ml-2 pl-2 mr-2 pr-2"
                      title="Eliminar"
                      @click="deleteNewImg(i)"
                    >
                      <i class="fa fa-close m-0 p-0" aria-hidden="true"></i>
                    </button>
                  </td>
                </tr>
              </template>
            </tbody>
          </table>
        </div>

        <div v-if="this.form.type_id != 6" class="col-12" style="text-align: initial">
          <button
            v-if="mainImage != null"
            @click="setMainImage(mainImage)"
            type="button"
            class="btn btn-success btn-sm mx-2"
          >
            <template v-if="loading.changeDoc">
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              Cargando...
            </template>
            <template v-else>Actualizar imagen principal</template>
          </button>
          <button
            v-if="flagImgsSelected == true"
            @click="saveAllImg()"
            type="button"
            class="btn btn-success btn-sm button-login"
          >
            <template v-if="loading.imgs">
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              Cargando...
            </template>
            <template v-else>Actualizar imagenes</template>
          </button>
        </div>

        <!-- RELACIOMES -->
        <div class="col-12 mb-3 mt-5">
          <label style="color: #616161;"> <b> RELACIONAR IMÁGENES </b> </label
          ><br />
        </div>
        <div class="col-12" style="text-align: initial">
          <label
            class="ml-1"
            for="state"
            style="color: #616161; font-size: 14px"
            ><b
              >Seleccione las imágenes que estarán relacionadas a este
              producto.</b
            >
          </label>
          <multiselect
            :max="6"
            v-model="listRelations"
            tag-placeholder="Agregan item"
            placeholder="Buscar productos"
            label="name"
            :custom-label="nameWithLang"
            track-by="id"
            :options="listProducts"
            :multiple="true"
            :taggable="true"
          ></multiselect>
        </div>
        <div class="col-12">
          <span
            class="text-info float-left small mb-2 mt-2"
            style="text-align: initial"
            >Sólo se admiten 6 productos relacionados.</span
          >
        </div>

        <div class="col-12 mt-3 mb-3" style="text-align: end">
          <button
            @click="imgRelations()"
            type="button"
            class="btn btn-info btn-sm button-login"
          >
            <template v-if="loading.changeDoc">
              <span
                class="spinner-border spinner-border-sm"
                role="status"
                aria-hidden="true"
              ></span>
              Cargando...
            </template>
            <template v-else>Editar relación</template>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import $ from "jquery";
import axios from "axios";

export default {
  components: { Multiselect },
  data() {
    return {
      sizes: {
        info: null,
        availability: null,
      },
      sizes_lub: {
        info: null,
        availability: null,
      },
      mainImage: null,
      listSizes: [],
      productId: null,
      main: null,
      value: [],
      listRelations: [],
      listProducts: [],
      listFile: [],
      searchN: "",
      errorsFile: false,
      errorsFile2: false,
      errorsTitle: false,
      errorsStatus: false,
      form: {
        id: 0,
        urlImg: "",
        name: "",
        status: null,
        type_catalogue: null,
        points: null,
        points_lub: 0,
        price: null,
        description: "",
        color: null,
        type_id: null,
        sku: null,
        sizes: [],
        sizes_lub: [],
        checked: false,
      },
      errors: {
        id: 0,
        urlImg: "",
        name: "",
        status: null,
        type_catalogue: null,
        points: null,
        points_lub: 0,
        price: null,
        description: "",
        listR: false,
        type_id: null,
      },
      currentForm: {},
      file: null,
      loading: {
        publicate: false,
        history: false,
        changeDoc: false,
        imgs: false,
        order: false,
        all: false,
        table: false,
      },
      hidden: {
        btn: false,
      },
      paginate: ["items"],
      page: 1,
      totalPage: 1,
      isWon: false,
      productEdit: null,

      total_M: 0,
      total_redeemed_M: 0,
      total_remaining_M: 0,
      total_L: 0,
      total_redeemed_L: 0,
      total_remaining_L: 0,

      flagImgsSelected: false,
    };
  },
  methods: {
    getSizes() {
      axios
        .get("superAdmin/get/list/size")
        .then((res) => {
          if (res.data.cod == 0) {
            this.listSizes = res.data.data;
            // console.log('this.listSizes ', JSON.stringify(this.listSizes));
          }
        })
        .catch((error) => {
          console.log(error);
        });
    },
    removeSize(i) {
      this.form.sizes.splice(i, 1);
    },
    removeSizeLub(i) {
      this.form.sizes_lub.splice(i, 1);
    },
    addSizes() {
      if (this.sizes.info == null || this.sizes.availability == null) {
        this.$swal({
          confirmButtonColor: "#dc3545",
          icon: "warning",
          title: "Oops...",
          text: "El tipo de talla y la cantidad es obligatorio para esta acción",
        });
        return false;
      } else {
        let idSize = this.form.sizes.find((element) => element.id == this.sizes.info.id);
        if(idSize){
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "warning",
            title: "Oops...",
            html: `La talla <strong style="color:#dc3545">${idSize.name}</strong> ya está agregada con <strong style="color:#dc3545">${idSize.availability}</strong> unidades.`,
          });
          return false;
        } else {
          this.form.sizes.push({
            name: this.sizes.info.name,
            id: this.sizes.info.id,
            availability: this.sizes.availability,
          });
          setTimeout(() => {
            this.sizes.info = null;
            this.sizes.availability = null;
          }, 20);
        }
      }
    },
    addSizesLub() {
      if (this.sizes_lub.info == null || this.sizes_lub.availability == null) {
        this.$swal({
          confirmButtonColor: "#dc3545",
          icon: "error",
          title: "Oops...",
          text: "El tipo de talla o la cantidad es obligatorio para esta acción",
        });
        return false;
      } else {
        let idSizeLub = this.form.sizes_lub.find((element) => element.id == this.sizes_lub.info.id);
        if(idSizeLub){
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "warning",
            title: "Oops...",
            html: `La talla <strong style="color:#dc3545">${idSizeLub.name}</strong> ya está agregada con <strong style="color:#dc3545">${idSizeLub.availability}</strong> unidades.`,
          });
          return false;
        } else {
          this.form.sizes_lub.push({
            name: this.sizes_lub.info.name,
            id: this.sizes_lub.info.id,
            availability: this.sizes_lub.availability,
          });
          setTimeout(() => {
            this.sizes_lub.info = null;
            this.sizes_lub.availability = null;
          }, 20);
        }
      }
    },
    showCantAdd_M(){
      $("#modalSizesAdd_M").modal("show");
    },
    showCantRedeem_M(){
      $("#modalSizesRedeem_M").modal("show");
    },
    showCantRemaining_M(){
      $("#modalSizesRemaining_M").modal("show");
    },
    showCantAdd_L(){
      $("#modalSizesAdd_L").modal("show");
    },
    showCantRedeem_L(){
      $("#modalSizesRedeem_L").modal("show");
    },
    showCantRemaining_L(){
      $("#modalSizesRemaining_L").modal("show");
    },
    closedModal(){
      // Cierra los modales de las tallas para Motero
      $("#modalSizesAdd_M").modal("hide");
      $("#modalSizesRedeem_M").modal("hide");
      $("#modalSizesRemaining_M").modal("hide");

      // Cierra los modales de las tallas para Lubricador
      $("#modalSizesAdd_L").modal("hide");
      $("#modalSizesRedeem_L").modal("hide");
      $("#modalSizesRemaining_L").modal("hide");
    },
    deleteImg(data, i) {
      if(data.principal == true){
        this.$swal({
          title: "¡Atención!",
          text: "Debes elegir otra imagen como principal del producto antes de continuar",
          icon: "info",
          confirmButtonText: "Ok",
          confirmButtonColor: "#dc3545",
        });
      } else {
        this.$swal({
          title: "¿Está seguro que desea eliminar la imágen?",
          text: "Una vez eliminado no se puede volver a recuperar",
          icon: "info",
          showCancelButton: true,
          cancelButtonText: "Cancelar",
          confirmButtonColor: "#dc3545",
          cancelButtonColor: "#1da5df",
          confirmButtonText: "Eliminar",
        }).then((result) => {
          if (result.value) {
            this.eliminar(data, i);
          }
        });
      }
    },
    eliminar(data, i) {
      // console.log(data);
      this.loading.table = true;
      axios
        .get(
          "superAdmin/product/" +
            data.product_id +
            "/imgs/" +
            data.id +
            "/delete"
        )
        .then((res) => {
          if (res.data.cod == 0) {
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "success",
              title: "Muy bien",
              text: res.data.message,
            });
            this.listFile.splice(i, 1);
          }
          this.loading.table = false;
        })
        .catch((error) => {
          this.loading.table = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          });
        });
    },
    deleteNewImg(i){
      this.listFile.splice(i, 1);
      this.$refs.fileInput.value = '';
    },
    nameWithLang({ name, description, product_type_id }) {
      if (
        product_type_id == 1 ||
        product_type_id == 2 ||
        product_type_id == 4
      ) {
        return `${name} — ${description}`;
      } else {
        return `${name}`;
      }
    },
    onfileSelected(event) {
      let app = this;
      var fileSize = null;
      var extension = null;
      var numFile = app.listFile.length;
      var totalImg = numFile + event.target.files.length;
      if (totalImg < 6) {
        for (let i = 0; i < event.target.files.length; i++) {
          fileSize = event.target.files[i].size;
          extension = event.target.files[i].name.split(".");
          if (fileSize > 1000000) {
            app.errorsFile = "El archivo no debe superar 1MB. ";
            return false;
          }
          if (
            extension[1] != "jpg" &&
            extension[1] != "png" &&
            extension[1] != "jpeg"
          ) {
            app.errorsFile2 = " La extensión es inválida. ";
            return false;
          } else {
            app.errorsFile = false;
            app.errorsFile2 = false;
            var reader = new FileReader();
            reader.readAsDataURL(event.target.files[i]);
            reader.onload = function(e) {
              $(".img-h-" + i).attr("src", e.target.result);
            };
            app.listFile.push({ file: event.target.files[i], index: i });
            app.flagImgsSelected = true;
          }
        }
      } else {
        app.errorsFile = "No se pueden adjuntar más de 5 imágenes. ";
        return false;
      }
    },
    search() {
      this.items = [];
      this.loading.history = true;
      axios
        .get("superAdmin/product/moto/" + this.searchN)
        .then((res) => {
          if (res.data.cod == 0) {
            this.items = res.data.data;
            this.totalPage = Math.ceil(parseInt(this.items.length) / 9);
          }
          this.loading.history = false;
        })
        .catch((error) => {
          this.loading.history = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          });
        });
    },
    validformEdit() {
      let app = this;
      // if(app.listFile.length == 0 && this.form.type_id != 6){
      //   app.errorsFile = "La imagen es requerida";
      // }
      if(!app.form.name) {
        app.errors.name = "El nombre del producto es requerido.";
      }
      if(!app.form.description){
        app.errors.description = "La descripción del producto es requerida.";
      }
      if(app.form.type_catalogue == null){
        app.errors.type_catalogue = "EL tipo de catálogo es requerido";
      }
      if(app.form.type_catalogue == 2){
        if (app.form.points_lub == 0) {
          app.errors.points_lub = "La cantidad de puntos es requerida.";
        }
      }
      if(app.form.type_catalogue == 3){
        if (!app.form.points) {
          app.errors.points = "La cantidad de puntos es requerida.";
        }
        if (!app.form.points_lub) {
          app.errors.points_lub = "La cantidad de puntos es requerida.";
        }
      }
      if(!app.form.points){
        app.errors.points = "La cantidad de puntos es requerida.";
      }
      if(!app.form.price){
        app.errors.price = "El precio del producto es requerido.";
      }
      if(!app.form.status){
        app.errors.status = "El estado del producto es requerido.";
      }
      if(app.form.type_catalogue == 1){
        if(app.form.sizes.length == 0){
          alert("Debe seleccionar tallas para Motero");
          return false;
        }
      }
      if(app.form.type_catalogue == 2){
        if(app.form.sizes.length == 0){
          alert("Debe seleccionar tallas para Lubricador");
          return false;
        }
      }
      if(app.form.type_catalogue == 3){
        if(app.form.sizes.length == 0){
          alert("Debe seleccionar tallas para Motero");
          return false;
        }
        if(app.form.sizes_lub.length == 0){
          alert("Debe seleccionar tallas para Lubricador");
          return false;
        }
      }

      if (
        // !app.errorsFile &&
        !app.errorsTitle &&
        !app.errors.name &&
        !app.errors.status &&
        !app.errors.description &&
        !app.errors.type_catalogue &&
        !app.errors.points &&
        !app.errors.points_lub &&
        !app.errors.price
      ) {
        return true;
      }

      return false;
    },
    // validformEdit() {
    //   return true;
    // },
    updatePublication() {
      if (this.validformEdit()) {
        // console.log("good update");
        this.postUpdate();
      }
    },

    // ACTUALIZAR INFO
    saveAllImg() {
      this.loading.imgs = true;
      const formData1 = new FormData();
      var list = [];
      for (let i = 0; i < this.listFile.length; i++) {
        if (this.listFile[i].index != null) {
          list.push(this.listFile[i].file);
        }
      }
      for (let j = 0; j < list.length; j++) {
        formData1.append("imgs[" + j + "]", list[j]);
      }
      formData1.append("productId", this.$route.params.id);
      axios
        .post("superAdmin/product/imgs/assign", formData1)
        .then((res) => {
          if (res.data.cod == 0) {
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "success",
              title: "Muy bien",
              text: res.data.message,
            });
            this.loading.imgs = false;
            // location.reload();
            this.getProducts();
            this.getDetails();
          }
        })
        .catch((error) => {
          this.loading.imgs = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          });
        });
    },
    setMainImage(image) {
      this.loading.changeDoc = true;
      axios
        .put("admin/file/update/mainImage/" + image)
        .then((res) => {
          if (res.data.cod == 0) {
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "success",
              title: "Imagen principal actualizada",
              text: res.data.message,
            });
            this.loading.changeDoc = false;
            this.getProducts();
            this.getDetails();
          }
        })
        .catch((error) => {
          this.loading.changeDoc = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: error.response.data.data == 'already main' ? "info" : "error",
            title: "Oops...",
            text: error.response.data.message,
          });
        });
      this.mainImage = null;
    },

    // EDITAR RELACIONES
    imgRelations() {
      var listP = [];
      for (let i = 0; i < this.listRelations.length; i++) {
        listP.push({ relatedId: this.listRelations[i].id });
      }
      var data = {
        id: this.$route.params.id,
        products: listP,
      };
      axios
        .post("superAdmin/product/related/update", data)
        .then((res) => {
          if (res.data.cod == 0) {
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "success",
              title: "Muy bien",
              text: res.data.message,
            });
            this.loading.changeDoc = false;
          }
        })
        .catch((error) => {
          this.loading.changeDoc = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          });
        });
    },
    postUpdate() {
      var id = this.$route.params.id;
      var data = {
        status_id: this.form.status,
        type_catalogue: this.form.type_catalogue,
        points: this.form.points,
        points_lub: this.form.points_lub,
        price: this.form.price,
        description: this.form.description,
        sku: this.form.sku,
        update_product: this.form.checked,
      };
      // console.log("dataPut:", data);
      if (this.form.name != this.currentForm.name) {
        data.name = this.form.name;
      }
      this.loading.changeDoc = true;
      axios
        .post("superAdmin/product/moto/" + id, data)
        .then((res) => {
          // console.log(res.data.data);
          if (res.data.cod == 0) {
            this.saveSizes();
            this.getProducts();
            // this.$swal({
            //   confirmButtonColor: "#dc3545",
            //   icon: "success",
            //   title: "Muy bien",
            //   text: res.data.message,
            // });
          }
          // this.loading.changeDoc = false;
        })
        .catch((error) => {
          this.loading.changeDoc = false;
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          });
        });
    },
    saveSizes() {
      var data = {
        productId: this.$route.params.id,
        sizes: this.form.sizes,
        sizes_lub: this.form.sizes_lub,
      };
      this.loading.changeDoc = true;
      axios
        .post("api/size/assign", data)
        .then((res) => {
          this.loading.changeDoc = false;
          if (res.data.cod == 0) {
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "success",
              title: "Muy bien",
              text: res.data.message,
            });
          }
          this.loading.changeDoc = false;
        })
        .catch((error) => {
          this.loading.changeDoc = false;
          if (this.form.type_id !== 6) {
            this.$swal({
              confirmButtonColor: "#dc3545",
              icon: "error",
              title: "Oops...",
              text: error.response.data.message,
            });
          }
        });
    },
    getProducts() {
      var data = this.$route.params.id;
      this.listProducts = [];
      axios
        .get("superAdmin/product/moto")
        .then((res) => {
          if (res.data.cod == 0) {
            this.listProducts = res.data.data;
            this.listProducts.forEach(element => {
              if(element.id == data){
                this.productEdit = element;
              }
            });
          }
        })
        .catch((error) => {
          this.$swal({
            confirmButtonColor: "#dc3545",
            icon: "error",
            title: "Oops...",
            text: error.response.data.message,
          });
        });
    },
    getDetails() {
      var data = this.$route.params.id;
      this.loading.all = true;
      this.loading.table = true;
      axios
        .get("superAdmin/product/get/detail/" + data)
        .then((res) => {
          this.loading.all = false;
          this.loading.table = false;
          // console.log(JSON.stringify(res.data.data));
          if (res.data.cod == 0) {
            this.form = res.data.data;
            this.form = {
              id: res.data.data.id,
              urlImg: res.data.data.img,
              name: res.data.data.name,
              status: res.data.data.status_id,
              type_catalogue: res.data.data.type_catalogue,
              points: res.data.data.points,
              points_lub: res.data.data.points_lub,
              price: res.data.data.price,
              description: res.data.data.description,
              color: res.data.data.color,
              type_id: res.data.data.product_type_id,
              sku: res.data.data.sku,
              sizes: [],
              sizes_lub: [],
              checked: res.data.data.update_product,
            };
            this.currentForm = this.form;
            this.form.sizes = [];
            this.form.sizes_lub = [];

            for (let i = 0; i < res.data.data.product_size.length; i++) {
              if(res.data.data.product_size[i].type_size == 0){
                this.form.sizes.push({
                  id: res.data.data.product_size[i].sizes.id,
                  name: res.data.data.product_size[i].sizes.name,
                  availability: res.data.data.product_size[i].availability,
                  amount_total: res.data.data.product_size[i].amount_total,
                  amount_redeemed: res.data.data.product_size[i].amount_redeemed,
                  amount_remaining: res.data.data.product_size[i].amount_remaining,
                });
                this.total_M = this.form.sizes.reduce((total, item) => total + item.amount_total, 0);
                this.total_redeemed_M = this.form.sizes.reduce((total, item) => total + item.amount_redeemed, 0);
                this.total_remaining_M = this.form.sizes.reduce((total, item) => total + item.amount_remaining, 0);
              }
            }

            for (let i = 0; i < res.data.data.product_size.length; i++) {
              if(res.data.data.product_size[i].type_size == 1){
                this.form.sizes_lub.push({
                  id: res.data.data.product_size[i].sizes.id,
                  name: res.data.data.product_size[i].sizes.name,
                  availability: res.data.data.product_size[i].availability,
                  amount_total: res.data.data.product_size[i].amount_total,
                  amount_redeemed: res.data.data.product_size[i].amount_redeemed,
                  amount_remaining: res.data.data.product_size[i].amount_remaining,
                });
                this.total_L = this.form.sizes_lub.reduce((total, item) => total + item.amount_total, 0);
                this.total_redeemed_L = this.form.sizes_lub.reduce((total, item) => total + item.amount_redeemed, 0);
                this.total_remaining_L = this.form.sizes_lub.reduce((total, item) => total + item.amount_remaining, 0);
              }
            }

            this.listFile = [];
            this.listFile.push({ principal: true, url: res.data.data.img });
            for (let i = 0; i < res.data.data.file.length; i++) {
              res.data.data.file[i].index = null;
              this.listFile.push(res.data.data.file[i]);
            }
            // console.log(JSON.stringify(this.listFile));
            this.listRelations = [];
            for (let i = 0; i < res.data.data.relation.length; i++) {
              this.listRelations.push(res.data.data.relation[i].product);
            }
          }
        })
        .catch((error) => {
          console.log(error);
          this.loading.table = false;
          this.loading.all = false;
        });
    },
  },
  mounted() {
    this.getSizes();
    this.getProducts();
    this.getDetails();
  },
  watch: {
    value: function(newV) {
      // console.log(newV.length);
      if (newV.length >= 6) {
        this.errors.listR = "Sólo se admiten 6 productos relacionados";
      } else {
        this.errors.listR = false;
      }
    },
    searchN: function(newN) {
      if (!newN) {
        setTimeout(() => this.getProducts(), 15000);
      }
    },
    "form.name": function(newV) {
      if (!newV) {
        this.errors.name = "El nombre del producto es requerido.";
      } else {
        this.errors.name = false;
      }
    },
    "form.description": function(newV) {
      if (!newV) {
        this.errors.description = "La descripción del producto es requerida.";
      } else {
        this.errors.description = false;
      }
    },
    "form.type_catalogue": function(newV){
      if(!newV){
        this.errors.type_catalogue = "El tipo de catálogo es requerido";
      } else {
        this.errors.type_catalogue = false;
      }
    },
    "form.points": function(newV) {
      if (!newV) {
        this.errors.points = "La cantidad de puntos es requerida.";
      } else {
        this.errors.points = false;
      }
    },
    "form.points_lub": function(newV) {
      if (!newV) {
        this.errors.points_lub = "La cantidad de puntos es requerida.";
      } else {
        this.errors.points_lub = false;
      }
    },
    "form.price": function(newV) {
      if (!newV) {
        this.errors.price = "El precio del producto es requerido.";
      } else {
        this.errors.price = false;
      }
    },
    "form.status": function(newV) {
      if (!newV) {
        this.errors.status = "El estado del producto es requerido.";
      } else {
        this.errors.status = false;
      }
    },
    "form.urlImg": function(newV) {
      if (!newV && this.form.type_id != 6) {
        this.errors.urlImg = "La imagen del producto es requerida.";
      } else {
        this.errors.urlImg = false;
      }
    },
  },
};
</script>

<style>
.container-fluid,
.container-lg,
.container-md,
.container-sm,
.container-xl {
  padding-right: 0px !important;
  padding-left: 0px !important;
  overflow: hidden;
}
.hr-border {
  border-top: 1px solid rgb(198 198 198);
  height: 15px;
  width: 100%;
  background-color: white;
}
.div-button {
  margin-top: 50px;
  text-align: left;
}
.is-danger {
  border: solid 2px !important;
  border-color: #e9434c !important;
}
.alert-primary{
  color: #721c24;
  border: solid 1px red !important;
  border-color: #e9434c !important;
  background-color: #f8d7da !important;
}
.modal-title {
  color: black;
  font-weight: bold;
}
.modal-question {
  border: solid 3px;
  border-color: #dc3545;
  border-radius: 15px;
}
label {
  color: black;
  margin-right: 4px;
}
.img-banner {
  display: block;
  width: 25%;
  text-align: center;
  margin: auto;
}
td {
  text-align: center;
  vertical-align: -webkit-baseline-middle;
  cursor: all-scroll;
}
.table-container {
  overflow: auto;
}
h5 {
  margin-bottom: 10px !important;
}
.commentary1 {
  text-align: left !important;
  color: #1da5df !important;
  font-size: 13px !important;
}
.page-item.active .page-link {
  border-style: none;
  border-radius: 20px;
  background-color: #dc3545;
}
a.page-link {
  color: black;
  cursor: pointer;
}
a.page-link:hover {
  color: #dc3545;
}
.page-link {
  background-color: #f5f5dc00;
  border-radius: 20px;
  border-color: none;
}
.page-item.disabled .page-link {
  color: #dc3545;
  background-color: #fff0;
  border-color: #dee2e600;
}
.ul-pagination {
  padding: 0px;
}
.multiselect__tag {
  background-color: #dc3545 !important;
}
.multiselect__tag-icon:after {
  color: #ffffff;
  font-size: 18px;
}
.multiselect__tag-icon:hover {
  color: #ffffff;
  font-size: 18px;
  background-color: #b80012;
}
.multiselect__option--highlight {
  background: #17a2b8;
  outline: none;
  color: #fff;
}
#boton_rrss {
  height: 30px;
  background-color: #fff;
  padding: 3px 6px 0px 0px;
  border-radius: 50px;
  cursor: pointer;
  z-index: 10;
}
#boton_rrss button{
  color: #dc3545;
}
</style>
